import React from 'react';
import { cn } from '../../utils/cn';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {}
export function Card({
  className,
  ...props
}: CardProps) {
  return <div className={cn('rounded-lg border border-slate-200 bg-white text-slate-950 shadow-sm', className)} {...props} data-id="element-270" />;
}
export function CardHeader({
  className,
  ...props
}: CardProps) {
  return <div className={cn('flex flex-col space-y-1.5 p-6', className)} {...props} data-id="element-271" />;
}
export function CardTitle({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={cn('font-semibold leading-none tracking-tight text-slate-900', className)} {...props} data-id="element-272" />;
}
export function CardContent({
  className,
  ...props
}: CardProps) {
  return <div className={cn('p-6 pt-0', className)} {...props} data-id="element-273" />;
}
export function CardFooter({
  className,
  ...props
}: CardProps) {
  return <div className={cn('flex items-center p-6 pt-0', className)} {...props} data-id="element-274" />;
}